
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 18.443a3.333 3.333 0 100-6.667 3.333 3.333 0 000 6.667z","fill":"#848DB0"}}),_c('path',{attrs:{"d":"M22.89 6.221h-3.523l-1.377-1.5A2.211 2.211 0 0016.356 4h-4.71c-.623 0-1.223.267-1.645.722l-1.367 1.5H5.112c-1.222 0-2.222 1-2.222 2.222v13.334c0 1.222 1 2.222 2.222 2.222H22.89c1.222 0 2.222-1 2.222-2.222V8.443c0-1.222-1-2.222-2.222-2.222zM14 20.666a5.558 5.558 0 01-5.555-5.556 5.558 5.558 0 015.556-5.555 5.558 5.558 0 015.555 5.555 5.558 5.558 0 01-5.555 5.556z","fill":"#848DB0"}})])
          )
        }
      }
    